import { Map as ImmutableMap, Record } from 'immutable';
import { defaultAccountProps } from '../../flux/accounts/accountsTypes';

// 'data/accounts/types';

//  const log = getLogger('data/goals/types');

export const mkGoalsStore = Record({
  resourcesById: ImmutableMap(),

  lastSyncDate: undefined,
  loadPending: true,

  isLoading: false,
  pendingAmount: undefined,
});

// ////////////////////////////////////////////////////////////////////////////////////////////////
// Goal - Base Goal Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////

// WARNING - If you provide any default goals props here, you need to explicitly remove them in
// mkUpdateGoal below, to prevent overwriting these values when someone is trying to update only
// specific fields in a goal.
//
const defaultGoalProps = {
  id: undefined,
  clientId: undefined,
  accountId: undefined,

  name: undefined,

  contributionAmount: undefined,
  contributionFrequency: undefined,
  contributedThisMonth: undefined,
  createdAt: undefined,

  tagId: undefined,
  targetAmount: undefined,
  targetOn: undefined,
  startOn: undefined,
  notes: undefined,
  imageId: undefined,
  description: undefined,
  completedOn: undefined,
  initialAccount: undefined,
  isDeleted: false,
  modifiedAt: undefined,
  savedSoFar: undefined,
  spent: undefined,

  isTakenFromF2S: undefined,

  txnIds: undefined,
};

// ================================================================================================
// Save for __________  Properties & Types
// ================================================================================================

export const mkSaveForOther = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_OTHER',
});
export const mkSaveForWedding = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_WEDDING',
});
export const mkSaveForCar = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_CAR',
});
export const mkSaveForHome = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_HOME',
});

export const mkSaveForEmergencyFund = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_EMERGENCY_FUND',
});

export const mkSaveForVacation = Record({
  ...defaultGoalProps,
  type: 'SAVE_FOR_VACATION',
});

export const mkGoal = (type, options) => {
  switch (type) {
    case 'SAVE_FOR_OTHER':
      return mkSaveForOther(options);
    case 'SAVE_FOR_EMERGENCY_FUND':
      return mkSaveForEmergencyFund(options);
    case 'SAVE_FOR_WEDDING':
      return mkSaveForWedding(options);
    case 'SAVE_FOR_CAR':
      return mkSaveForCar(options);
    case 'SAVE_FOR_HOME':
      return mkSaveForHome(options);
    case 'SAVE_FOR_VACATION':
      return mkSaveForVacation(options);
    default:
      //  log.warn('Was a new Goal Type added? Need to update mkGoal'); TODO: I do not know why this warning is here, it all seems to be working fine. Perhaps something else was to eventually be added? Regardless, custom goals work just fine so this warning isn't required.
      return mkSaveForOther(options);
  }
};

export const mkUpdateGoal = (type, options) => {
  const x = mkGoal(type, {
    ...options,
  });
  return x;
};

const defaultGoalBalanceProps = {
  accountId: undefined,
  goalType: 'SAVE_FOR_OTHER',
  grossBalance: 0,
  netBalance: 0,
  balanceBreakdown: undefined,
};

const defaultGoalSubBalanceProps = {
  accountId: undefined,
  grossBalance: 0,
  netBalance: 0,
  grossContribPct: 0,
  netContribPct: 0,
};

// SubBalance is the balance for each incoming account

// GoalBalance is the parent balance object for each goal

export const mkGoalSubBalance = Record({ ...defaultGoalSubBalanceProps });

export const mkGoalBalance = Record({ ...defaultGoalBalanceProps });

const defaultGoalFundingAccountProps = {
  ...defaultAccountProps,
  availableBalance: 0,
  goalsBalance: 0,
  description: undefined,
  goalContribution: 0,
  subtext: undefined,
};

export const mkGoalFundingAccount = Record({ ...defaultGoalFundingAccountProps });
